import script from "./keyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./keyuan.vue?vue&type=script&setup=true&lang=js"

import "./keyuan.vue?vue&type=style&index=0&id=9b08e3d0&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b08e3d0"]])

export default __exports__